<script>
export default {
  name: 'PackageAddonBody',
  props: {
    componentDataObject: {
      type: Array,
      default() {
        return []
      },
    },
    fraudPlusPackageDetails: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      fraudPlusProductAddOnsData: [],
    }
  },
  computed: {},
  mounted() {
    this.fraudPlusProductAddOnsData = this.fraudPlusPackageDetails
      .filter(function(i, n) {
        return i.checked === true
      })
      .map(function(p, q) {
        return p.indexValue
      })
  },
  methods: {
    onChangeAddons(evt) {
      this.fraudPlusPackageDetails
        .filter((x) => evt.includes(x.indexValue))
        .forEach(function(item) {
          item.checked = true
        })
      this.fraudPlusPackageDetails
        .filter((x) => !evt.includes(x.indexValue))
        .forEach(function(item) {
          item.checked = false
        })
    },
  },
}
</script>
<template>
  <b-card-body>
    <b-form-checkbox-group
      v-model="fraudPlusProductAddOnsData"
      :options="fraudPlusPackageDetails"
      class="mb-3 check-box-group"
      value-field="indexValue"
      text-field="fraudPlusProductAddOnName"
      size="lg"
      inline
      @change="onChangeAddons"
    >
    </b-form-checkbox-group>
  </b-card-body>
</template>
<style lang="scss" module>
@import '@design';
.nooutline {
  font-weight: bold;
  color: #000 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
